import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-montana-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./montana-state-form.component.html",
  styleUrl: "./montana-state-form.component.scss",
})
export class MontanaStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
